import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class FileList extends React.Component {

    render() {

        const files = this.props.files.map((file, index) => {

            return <li key={index}><span className="amt-file-name">{file.name}</span> <span className="amt-delete-file" onClick={() => this.props.onFileRemove(file)}><FontAwesomeIcon icon="times"/></span></li>
        });

        return (
            <div className="amt-files">
                <div className="amt-files-title">Added Files:</div>
                <ul className="amt-file-list">
                    {files}
                </ul>
            </div>
        );
    }
}